import { FC, memo, ReactNode, useState } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import { useSystemMessage } from "@/hooks/systemMessage";
import { clipboardcopy } from "@/utils/common";

interface Props {
  value: string;
  children?: ReactNode;
  className?: string;
  balloon?: ReactNode;
  message?: string;
  onClick?: (val: string, result: boolean) => void;
}

/**
 * valueに設定した値をクリップボードにコピーする
 * @param param0
 * @returns
 */
const ClipboardCopyButtonBase: FC<Props> = ({
  value,
  children,
  className,
  balloon,
  message,
  onClick,
}) => {
  const systemMessage = useSystemMessage();

  // TODO:バルーンやポップ表示について、仕様確定次第修正
  const [showBalloon, setBalloon] = useState<boolean>(false);

  const clipboardCopyHandler = async (val: string) => {
    await clipboardcopy(val).then((result) => {
      if (result) {
        // 小さいバルーンを表示する場合、balloonにReactNodeを設定する
        if (balloon !== undefined) {
          setBalloon(true);
          setTimeout(function () {
            setBalloon(false);
          }, 1000);
        }
        // systemMessageを表示する場合、messageを設定する
        if (message) {
          systemMessage.info(message);
        }
        // コピー後に何か処理する場合、onClickを設定する
        if (onClick !== undefined) {
          onClick(val, result);
        }
      }
    });
  };

  return (
    <>
      {children ? (
        <div
          className={className}
          onClick={() => {
            void clipboardCopyHandler(value);
          }}
        >
          {children}
        </div>
      ) : (
        <Button
          label="コピー"
          color="primary"
          size="input"
          spSize="lg"
          onClick={() => {
            void clipboardCopyHandler(value);
          }}
          className="whitespace-nowrap"
        />
      )}
      {balloon && showBalloon && balloon}
    </>
  );
};

export const ClipboardCopyButton = memo(ClipboardCopyButtonBase);
